const news2 = `## Personal Trainers Club Launches Demo Platform
**2025-06-13**

We're excited to announce the second public demo of The Personal Trainers Club! Trainers and clients can now explore the concept of the platform and provide feedback to help shape the future of PTC.
`;

export default news2;